'use client';

import { ReactNode, useCallback, useMemo } from 'react';
import type { IntlShape } from '@formatjs/intl';

type Selection = { id: string; handle: string };

const useFileUploadInstructions = (translations: IntlShape<ReactNode>) => {
  const uploadTypeId = useCallback(
    (selectedType: Selection, blocked: boolean) => {
      if (blocked) return '';
      if (!selectedType.handle) return '';
      return [selectedType.handle, 'INSTRUCTIONS'].join('.');
    },
    []
  );

  const uploadId = useCallback((isDragActive: boolean, blocked: boolean) => {
    if (blocked) return 'UPLOADING';
    if (isDragActive) return 'UPLOADING.DRAG_DROP';
    return 'UPLOADING.DRAG_DROP_CLICK';
  }, []);

  const uploadInstructions = useCallback(
    (selectedType: Selection, isDropActive: boolean, blocked: boolean) =>
      [uploadId(isDropActive, blocked), uploadTypeId(selectedType, blocked)]
        .filter((id) => !!id)
        .map((id) => translations.formatMessage({ id }))
        .join(' '),
    [uploadId, uploadTypeId, translations]
  );

  return useMemo(() => ({ uploadInstructions }), [uploadInstructions]);
};

export default useFileUploadInstructions;
